export function closeModal(e) {
    // Close modal if page is clicked, close button is clicked, or escape key is pressed
    if (e.target.classList.contains('modal') || e.target.classList.contains('close-button') || e.key === 'Escape') {
        const modalToClose = document.querySelector('.modal.open');

        if (modalToClose) {
            e.preventDefault();
            modalToClose.classList.remove('open');
            document.body.classList.remove('modal-open');

            const closeButtons = document.querySelectorAll('.modal .close-button');
            if (closeButtons) {
                closeButtons.forEach(closeButton => {
                    closeButton.removeEventListener('click', closeModal);
                });
            }

            const modals = document.querySelectorAll('.modal');
            if (modals) {
                modals.forEach(modal => {
                    modal.removeEventListener('click', closeModal);
                });
                document.removeEventListener('keydown', closeModal);
            }
        }
    }
}

export function openModal(e) {
    e.preventDefault();
    let modalToOpen;

    if (e.currentTarget) {
        const modalHref = e.currentTarget.getAttribute('href');
        modalToOpen = document.getElementById(modalHref);
    }

    if (modalToOpen) {
        modalToOpen.classList.add('open');
        document.body.classList.add('modal-open');
    }

    const closeButtons = document.querySelectorAll('.modal .close-button');
    if (closeButtons) {
        closeButtons.forEach(closeButton => {
            closeButton.addEventListener('click', closeModal);
        });
    }

    const modals = document.querySelectorAll('.modal');
    if (modals) {
        modals.forEach(modal => {
            modal.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', closeModal);
    }

    // Always reset scroll position within modal to top of modal.
    const modalScrollers = document.querySelectorAll('.modal .modal-scroller');
    if (modalScrollers) {
        modalScrollers.forEach(modalScroller => {
            modalScroller.scrollTop = 0;
        });
    }
}

export function initModal() {
    const modalLinks = document.querySelectorAll('[href*="#modal"]');
    if (document.querySelector('.modal') && modalLinks) {
        modalLinks.forEach(modalLink => {
            modalLink.addEventListener('click', openModal);
        });
    }
}
